import * as React from 'react';
import { PhotoReviews } from "../../../../PhotoReviews";
import * as main from "../../styles/main.module.scss";
import * as reviews from "./style.module.scss";
import videoRevData from "./videoRevData.json";
import photoRevData from "./photoRevData.json";

export const ReviewsBottom = () => {
  return (
    <section className={reviews.reviews}>
      <div className={main.containerFluid}>
        <h2 className={`${main.titleH2} ${reviews.title}`}>Отзывы</h2>
        <div className={`row ${reviews.row}`}>
          {videoRevData.map((elem, index) => (
            <div className={`col-lg-4 ${reviews.col}`} key={index}>
              <div className={reviews.wrap}>
                <iframe
                  className={reviews.video}
                  src={elem.link}
                  title={`${elem.name}, отзыв`}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
              <div className={reviews.name}>{elem.name}</div>
            </div>
          ))}
        </div>
        <PhotoReviews
          data={photoRevData}
          rowClassName={reviews.photosRow}
          textClassName={reviews.name}
          buttonsColor={'#E9B882'}
        />
      </div>
    </section>
  );
};
